import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	summaryLine: {
		alignItems: 'center',
		display: 'inline-flex',
		flexWrap: 'wrap',
		gap: SPACE[4],
	},
	activityCell: {
		alignItems: 'center',
		display: 'inline-flex',
		gap: SPACE[4],
	},
	activityLink: {
		color: THEME.colors.primary.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		padding: 0,
	},
	loadMore: {
		display: 'flex',
		justifyContent: 'center',
		paddingTop: SPACE[8],
	},
});
